/*@ngInject*/
const RenewalRepository = function (baseRepository, notificationConstant) {

    angular.extend(this, baseRepository);

    this.submitRenewal = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/submitRenewal',
            config = {
                params: {
                    disableAutomation: true
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.submitNonRenewal = function (submissionId, reason, detail) {
        var url = '/rest/Submission/' + submissionId + '/submitNonRenewal',
            config = {
                params: {
                    reason: reason,
                    detail: detail,
                    notification: notificationConstant.email.NONE
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.retractNonRenewal = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/retractNonRenewal';
        return this.post(url);
    };


    this.markNonRenewed = function (submissionId, reason, detail) {
        var url = '/rest/Submission/' + submissionId + '/markNonRenewed',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.markRenewed = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/markRenewed',
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        return this.post(url, {}, config);
    };

    this.markExpired = function (submissionId, reason, detail) {
        var url = '/rest/Submission/' + submissionId + '/markExpired',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.flagForNonRenewal = function (submissionId, reason, detail) {
        var url = '/rest/Submission/' + submissionId + '/flagForNonRenewal',
            config = {
                params: {
                    reason: reason,
                    detail: detail,
                    notification: notificationConstant.email.NONE
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.clearNonRenewalFlag = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/clearNonRenewalFlag',
            config = {
                params: {
                    notification: notificationConstant.email.NONE
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('renewalRepository', RenewalRepository);
